import { DOMAIN } from "../../../../../var_env."
import { RemoveParams } from "../types"
import { RequestResponsePattern } from "../../../../../types/Request"
import { setRequestRemoveData, setRequestRemoveError, setRequestRemoveLoading, setRequestRemoveMessage } from "../Reducers/RamoAtividadeReducer"
import { deleteApi } from "../../../../../utils/requestApi"
import { RamoAtividadeType } from "../Types/RamoAtividadeType"

export default async function remove(dispatch: Function, values: RemoveParams){
    try {
        dispatch(setRequestRemoveLoading())
        
        const endpoint = `${DOMAIN}/RamoAtividade`
        const params = { id: values.id, idUsuario: values.idUsuario }
        const response: RequestResponsePattern<RamoAtividadeType> = await deleteApi({ endpoint, params })
        
        if(response){
            dispatch(setRequestRemoveData(response))
            if(!response.flagErro) dispatch(setRequestRemoveData(response))
            else throw new Error(response.listaMensagens[0])
        }else throw new Error('Erro na requisição')

    } catch (error: any) {
        dispatch(setRequestRemoveMessage(error.message ?? JSON.stringify(error)))
        dispatch(setRequestRemoveError())
    }
}